import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClockCounterClockwise, ArrowRight } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export default function History() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/search/history").then((r) => setRows(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-8 py-14">
      <h1 className="font-head text-3xl font-bold tracking-tight mb-1">Search History</h1>
      <p className="text-sm text-zinc-500 mb-8">Your recent hiring contact searches.</p>

      {loading ? (
        <p className="text-zinc-400 text-sm">Loading…</p>
      ) : rows.length === 0 ? (
        <div className="text-center py-20 border border-dashed border-zinc-200 rounded-xl">
          <ClockCounterClockwise size={32} className="mx-auto text-zinc-300 mb-3" />
          <p className="text-zinc-500 text-sm">No searches yet. Run your first search to see it here.</p>
        </div>
      ) : (
        <div className="space-y-2">
          {rows.map((r) => (
            <button key={r.search_id} data-testid={`history-${r.search_id}`} onClick={() => navigate(`/app/results/${r.search_id}`)}
              className="w-full flex items-center gap-4 p-4 bg-white border border-zinc-200 rounded-lg hover:border-zinc-400 transition-colors text-left group">
              {r.company?.logo && <img src={r.company.logo} alt="" className="w-9 h-9 rounded-md object-contain" onError={(e) => (e.target.style.display = "none")} />}
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-sm">{r.company?.name} · <span className="font-normal text-zinc-600">{r.target_role}</span></p>
                <p className="text-xs text-zinc-400">{new Date(r.created_at).toLocaleString()} · {r.count} contacts</p>
              </div>
              <ArrowRight size={16} className="text-zinc-300 group-hover:text-zinc-900 transition-colors" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
